import React, { useRef } from "react";

export default function ValueEditor({
  value,
  setValue,
  children,
  step
}: {
  value: string;
  setValue: (s: string) => void;
  children: React.ReactNode
  step: number
}) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const wrapSelection = (wrapper: "warning" | "code" | "pre") => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const selectedText = value.slice(start, end);

    let wrappedText = selectedText;
    if (wrapper === "warning") {
      console.log(123)
      wrappedText = `<span class="tWarning">${selectedText}</span>`;
    } else if (wrapper === "code") {
      wrappedText = `<span class="code">${selectedText}</span>`;
    } else if (wrapper === "pre") {
      wrappedText = `<pre class="code">${selectedText}</pre>`;
    }

    const newText = value.slice(0, start) + wrappedText + value.slice(end);

    setValue(newText);

    // Cursor'ı güncellenmiş konuma al
    requestAnimationFrame(() => {
      const newCursor = start + wrappedText.length;
      textarea.setSelectionRange(newCursor, newCursor);
      textarea.focus();
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    if (e.key === 'Tab') {
      e.preventDefault();

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      const tab = '  '; // İstersen '\t' yap ya da '    ' (4 boşluk)

      const newValue =
        value.slice(0, start) + tab + value.slice(end);

      setValue(newValue);

      // Cursor'ı yeni konuma al
      requestAnimationFrame(() => {
        const newCursor = start + tab.length;
        textarea.setSelectionRange(newCursor, newCursor);
      });
    }
  };


  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  return (
    <div className="">
      <div className="flex gap-2 mb-1 items-center pb-1">
        <div className="text-lg/none text-black w-7.5 py-1.5 font-bold text-center bg-yellow-600 rounded-full">{step}</div>
        <div className="font-medium text-lg">{children}</div>
        <button
          type="button"
          onClick={() => wrapSelection("warning")}
          className="text-yellow-600 bg-white/10 font-bold px-3 py-1 rounded ml-auto"
        >
          warning
        </button>
        <button
          type="button"
          onClick={() => wrapSelection("code")}
          className="text-yellow-600 bg-white/10 font-bold px-3 py-1 rounded"
        >
          codespan
        </button>
        <button
          type="button"
          onClick={() => wrapSelection("pre")}
          className="text-yellow-600 bg-white/10 font-bold px-3 py-1 rounded"
        >
          codeblock
        </button>
      </div>

      <textarea
        ref={textareaRef}
        className="bg-white/5 border border-white/10 rounded-lg p-4 w-full text-sm h-28 block"
        id="value"
        name="value"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        value={value}
        required
      />
    </div>
  );
}
